import { Asterisk } from "lucide-react";

const ITEMS = [
  { text: "Cultural Behavioral Psychology", style: "solid" },
  { text: "Author of 60+ Books", style: "outline" },
  { text: "Technology × Psychology × The Arts", style: "solid" },
  { text: "A 3.2-Million-Word Record", style: "outline" },
];

function Sequence() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <div key={i} className="flex shrink-0 items-center">
          <span
            className={`whitespace-nowrap px-8 font-serif text-5xl uppercase leading-none tracking-tight md:px-14 md:text-7xl ${
              item.style === "outline" ? "text-outline" : "text-bone"
            }`}
          >
            {item.text}
          </span>
          <Asterisk className="h-8 w-8 shrink-0 text-vermilion md:h-10 md:w-10" strokeWidth={1.5} />
        </div>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      aria-label="Editorial highlights"
      className="paused-hover overflow-hidden border-y border-line bg-ink2 py-10 md:py-14"
    >
      <div className="animate-marquee flex w-max will-change-transform">
        <Sequence />
        <div className="flex shrink-0 items-center" aria-hidden="true">
          {ITEMS.map((item, i) => (
            <div key={i} className="flex shrink-0 items-center">
              <span
                className={`whitespace-nowrap px-8 font-serif text-5xl uppercase leading-none tracking-tight md:px-14 md:text-7xl ${
                  item.style === "outline" ? "text-outline" : "text-bone"
                }`}
              >
                {item.text}
              </span>
              <Asterisk className="h-8 w-8 shrink-0 text-vermilion md:h-10 md:w-10" strokeWidth={1.5} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}